export default __webpack_public_path__ + "static/media/close-ico.abae9e4a.svg";